import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FaceRecognitionUIComponent } from './faceRecognitionUI.component';
import { AuthGuard } from '../auth.guard';

const routes: Routes = [
  {
    path: 'face-recognition',
    component: FaceRecognitionUIComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FaceRecognitionUIRoutingModule { }
